// extracted by mini-css-extract-plugin
module.exports = {"x":"PepText-pepxpress_x__2dYQg"};